// extracted by mini-css-extract-plugin
export default {"root":"LocationRolesActions_root__IcSr1","itemsSelected":"LocationRolesActions_itemsSelected__jfaKQ"};